import { ReactComponent as Sun } from "./assets/Sun.svg"
import { ReactComponent as Moon } from "./assets/Moon.svg"


export const displayGreeting = (currentHour) => {
    let displayImg = ""
    let greeting = ""
    if (currentHour < 12) {
        greeting = 'Good Morning,'
        displayImg = <Sun />
    }
    else if (currentHour >= 12 && currentHour < 18) {
        greeting = 'Good Afternoon,'
        displayImg = <Sun />
    }
    else {
        greeting = 'Good Evening,'
        displayImg = <Moon />
    }
    return ({ displayImg: displayImg, greeting: greeting })
}


export const CLOCK_IN_STATUS = 'Clock-In'
export const CLOCK_OUT_STATUS = 'Clock-Out'